import { useCreation } from 'ahooks'

import { GenericalRecord } from '../../../types/utilities'
import { ProColumnUnionType } from '../interface'
import { transformColumns } from '../utils/transformColumns'

export const useColumns = (
  columns: ProColumnUnionType<GenericalRecord, GenericalRecord>[],
  cellEmptyText: string,
  context?: GenericalRecord
) => {
  return useCreation(
    () => transformColumns(columns, cellEmptyText, context ?? {}),
    [columns, cellEmptyText, context]
  )
}
